import { FC, PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

import { RootState } from '@/utils/store';

interface PrivateRouteProps extends PropsWithChildren {
  redirectTo?: string;
}

const PrivateRoute: FC<PrivateRouteProps> = ({
  children,
  redirectTo = '/',
}) => {
  const location = useLocation();

  const isAuthenticated = useSelector((state: RootState) => !!state.auth.user);

  if (!isAuthenticated) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
